import {Subject, SubjectPayload} from './subject'

export interface ClassPayload {
    IDArtSchule: number
    Klassen: string
    Gruppe: string
    full_name: string
    subjects: SubjectPayload[]
    available_subjects: SubjectPayload[]
}

export class Class {

    IDArtSchule: number
    Klassen: string
    Gruppe: string
    fullName: string
    subjects: Subject[]
    availableSubjects: Subject[]

    constructor(data: ClassPayload) {
        this.IDArtSchule = data.IDArtSchule
        this.Klassen = data.Klassen
        this.Gruppe = data.Gruppe
        this.fullName = data.full_name
        this.subjects = <Subject[]>[]
        data.subjects?.forEach((item: SubjectPayload) => {
            this.subjects.push(new Subject(item))
        })
        this.availableSubjects = <Subject[]>[]
        data.available_subjects?.forEach((item: SubjectPayload) => {
            this.availableSubjects.push(new Subject(item))
        })
    }

    fill(data: ClassPayload): this {
        this.IDArtSchule = data.IDArtSchule
        this.Klassen = data.Klassen
        this.Gruppe = data.Gruppe
        this.fullName = data.full_name
        this.subjects = <Subject[]>[]
        data.subjects?.forEach((item: SubjectPayload) => {
            this.subjects.push(new Subject(item))
        })
        this.availableSubjects = <Subject[]>[]
        data.available_subjects?.forEach((item: SubjectPayload) => {
            this.availableSubjects.push(new Subject(item))
        })
        return this
    }

    exists(): boolean {
        return !!this.IDArtSchule
    }

    payloadSubjects(): SubjectPayload[] {
        let subjects = <SubjectPayload[]>[]
        this.subjects.forEach((item: Subject) => {
            subjects.push(item.payload())
        })
        return subjects
    }

    payloadAvailableSubjects(): SubjectPayload[] {
        let subjects = <SubjectPayload[]>[]
        this.subjects.forEach((item: Subject) => {
            subjects.push(item.payload())
        })
        return subjects
    }

    payload(): ClassPayload {
        return {
            IDArtSchule: this.IDArtSchule,
            Klassen: this.Klassen,
            Gruppe: this.Gruppe,
            full_name: this.fullName,
            subjects: this.payloadSubjects(),
            available_subjects: this.payloadAvailableSubjects(),
        }
    }
}
